{
  "... free cash flow in ... year": "{{freeCashFlow}} free cash flow in year {{year}}",
  "... in ... year": "{{value}} in year {{year}}",
  "... is ...": "{{ property }} is {{ value }}",
  "... is invalid": "{{ property }} is invalid",
  "... loan in ... year": "{{loan}} loan in year {{year}}",
  "... repayment in ... year": "{{repayment}} repayment in year {{year}}",
  "... should be between ... and ...": "{{ property }} should be between {{ min }} and {{ max }}",
  "... year": "{{value}} year",
  "... years": "{{value}} years",
  "...% in ... year": "{{percentage}}% in year {{year}}",
  "A combination building has non-residential rent above": "A combination building has non-residential rent above",
  "A new financing can only be made if all critical actions have been resolved. Check the actions tab.": "A new financing can only be made if all critical actions have been resolved. Amount of critic actions open: {{value}}. View the 'actions' tab which actions are still required",
  "A1Plus": "A+",
  "A2Plus": "A++",
  "A3Plus": "A+++",
  "A4Plus": "A++++",
  "AcceptedByLender": "Accepted by lender",
  "According to our estimate, the house does not fall into the private sector and there is a maximum rent that can be charged. The rent is according to the points system (home valuation system) at .... per month.": "According to our estimate, the house does not fall into the private sector and there is a maximum rent that can be charged. The rent is according to the points system (home valuation system) at {{value}} per month.",
  "Achieved": "Achieved",
  "Actions": "Actions",
  "Active": "Active",
  "Add": "Add",
  "Add all ... buildings": "Add all {{value}} buildings",
  "Add all ... documents": "Add all {{value}} documents",
  "Add AVM": "Add AVM",
  "Add building": "Add building",
  "Add buildings to this mortgage": "Add buildings to this mortgage",
  "Add client": "Add client",
  "Add collaboration": "Add collaboration",
  "Add collaboration members": "Add collaboration members",
  "Add company": "Add company",
  "Add company shareholders": "Add company shareholders",
  "Add director": "Add director",
  "Add loan part": "Add loan part",
  "Add mortgages to this building": "Add mortgages to this building",
  "Add new": "Add new",
  "Add new building": "Add new building",
  "Add new client": "Add new client",
  "Add new renovation": "Add new renovation",
  "Add new user": "Add new user",
  "Add new valuation": "Add new valuation",
  "Add renovation": "Add renovation",
  "Add room": "Add room",
  "Add shareholder": "Add shareholder",
  "Add unit": "Add unit",
  "Add user": "Add user",
  "Add valuation": "Add valuation",
  "Add valuator": "Add valuator",
  "Add your first building": "Add your first building",
  "Add your first mortgage": "Add your first mortgage",
  "Add your first rental contract": "Add your first rental contract",
  "Add your first tenant": "Add your first tenant",
  "Addition": "Addition",
  "Additional building information": "Additional building information",
  "At least one combination building has more than the non-residential rent share of this row of its unit rent from non-residential (CRE) units. Only combination buildings count, each on its own units; the building with the highest share decides.": "At least one combination building has more than the non-residential rent share of this row of its unit rent from non-residential (CRE) units. Only combination buildings count, each on its own units; the building with the highest share decides.",
  "Mark as repayed": "Mark as repaid",
  "Non-residential rent share": "Non-residential rent share",
  "The share of a combination building's unit rent that must come from non-residential (CRE) units, strictly above this percentage, for the condition \"A combination building has non-residential rent above\". A unit's rent is its rent income, else its rental value after renovation, else its rental value. The adjustment applies to the whole loan; combine it with the fixed interest period bounds for a surcharge per period band. Ignored for other conditions.": "The share of a combination building's unit rent that must come from non-residential (CRE) units, strictly above this percentage, for the condition \"A combination building has non-residential rent above\". A unit's rent is its rent income, else its rental value after renovation, else its rental value. The adjustment applies to the whole loan; combine it with the fixed interest period bounds for a surcharge per period band. Ignored for other conditions.",
  "additional income required": "additional income required",
  "Additional income required": "Additional income required",
  "AdditionalInformationRequested": "Additional information requested",
  "Address": "Address",
  "Adjust valuations": "Adjust valuations",
  "Adviser": "Adviser",
  "After renovation": "After renovation",
  "AlienDocumentEuOrEaaMemberState": "Vreemdelingendocument EU of EER lidstaat",
  "AligningConditions": "Aligning conditions",
  "All": "All",
  "All document types": "All document types",
  "All documents": "All documents",
  "Allow": "Allow",
  "Allow screensharing session": "Do you want to allow screen sharing? Only allow this when you trust the source.",
  "Amount per year": "Amount per year",
  "An invite was sent to the email adress. The user should follow the instructions to activate the account.": "An invite was sent to the email adress. The user should follow the instructions to activate the account.",
  "Analysing document…": "Analysing document…",
  "and ... other addresses": "... and {{value}} other addresses",
  "Annually": "Annually",
  "Annuity": "Annuity",
  "Apartment": "Apartment",
  "Application": "Application",
  "Application form": "Application form",
  "Application not found": "Application not found",
  "Applications": "Applications",
  "Archived": "Archived",
  "Are you planning to change (renovate) this building?": "Are you planning to change (renovate) this building?",
  "Are you planning to split this building in multiple buildings?": "Are you planning to split this building in multiple buildings?",
  "Are you sure you want to close ...?": "Are you sure you want to close {{value}}?",
  "Are you sure you want to delete ...?": "Are you sure you want to delete {{value}}?",
  "Arrangements": "Arrangements",
  "Assign the remaining share to": "Assign the remaining share to",
  "Association": "Association",
  "AtParents": "Living with parents",
  "AtPartner": "Living with partner",
  "Attach file": "Attach file",
  "Authority": "Authority",
  "Authorization required": "Authorization required",
  "Authorize": "Authorize",
  "Board member": "Board member",
  "Director": "Director",
  "Director added": "Director added",
  "Director updated": "Director updated",
  "Directors": "Directors",
  "Does not sign on behalf of the company": "Does not sign on behalf of the company",
  "Edit director": "Edit director",
  "Edit shareholder": "Edit shareholder",
  "Enter a share between 0 and 100": "Enter a share between 0 and 100",
  "former": "former",
  "Function": "Function",
  "Jointly authorized": "Jointly authorized",
  "Limited authority": "Limited authority",
  "Managing director": "Managing director",
  "Not yet assigned to other shareholders": "Not yet assigned to other shareholders",
  "present": "present",
  "Proxy holder": "Proxy holder",
  "Search person or company": "Search person or company",
  "Shareholder added": "Shareholder added",
  "Shareholder updated": "Shareholder updated",
  "Signs on behalf of the company": "Signs on behalf of the company",
  "Solely authorized": "Solely authorized",
  "Statutory director": "Statutory director",
  "Supervisory director": "Supervisory director",
  "The shares add up to": "The shares add up to",
  "This customer is already a shareholder": "This customer is already a shareholder",
  "Unknown": "Unknown",
  "Value models (AVM)": "Value models (AVM)",
  "Automatically generate financing proposals": "Automatically generate financing proposals",
  "AVM added": "AVM added",
  "Back": "Back",
  "Bad": "Bad",
  "Bad to moderate": "Bad to moderate",
  "BankAndSavingBalances": "Bank and saving balances",
  "Best ROE": "Best ROE",
  "Birthdate": "Birthdate",
  "Borrowers": "Borrowers",
  "Bought off until": "Bought off until",
  "building": "building",
  "Building": "Building",
  "Building 1": "Building 1",
  "Building deposit": "Building deposit",
  "Building details": "Building details",
  "Building information": "Building information",
  "buildings": "buildings",
  "Buildings": "Buildings",
  "Business": "Business",
  "Businesses": "Businesses",
  "By paying ... in advance": "By paying <strong>{{value}}</strong> in advance",
  "By reserving ...": "By reserving <strong>{{value}}</strong>",
  "Cafe": "Cafe",
  "Calculate": "Calculate",
  "Calculate net initial yield": "Calculate net initial yield",
  "Calculated points": "Calculated points",
  "Calculation method": "Calculation method",
  "Calculations": "Calculations",
  "Cancel": "Cancel",
  "Canceled": "Canceled",
  "Cancelled": "Cancelled",
  "Cancelled RC": "Cancelled",
  "Cash on cash": "Cash on cash",
  "Categorize": "Categorize",
  "Categorize document": "Categorize document",
  "Chamber of commerce number": "Chamber of commerce number",
  "Characteristic": "Characteristic",
  "Check": "Check",
  "Checked": "Checked",
  "City": "City",
  "Clear conversation": "Clear conversation",
  "Client": "Client",
  "Client adviser": "Client adviser",
  "Client dashboard": "Client dashboard",
  "Client details": "Client details",
  "Client documents (including related clients)": "Client documents (including related clients)",
  "Clients": "Clients",
  "Close": "Close",
  "Closed": "Closed",
  "Collaboration": "Collaboration",
  "Collaboration information": "Collaboration information",
  "Collaboration members": "Collaboration members",
  "Collaborations": "Collaborations",
  "Collateral type": "Collateral type",
  "Collateral value": "Collateral value",
  "CollectingAdditionalInformation": "Collecting additional information",
  "CollectingInformation": "Collecting information",
  "CommercialRental": "Commercial rental",
  "CommercialRentalPropertyConversion": "Commercial rental property conversion",
  "Company": "Company",
  "Company information": "Company information",
  "CompanyCorporationTax": "Company corporation tax",
  "CompanyIncomeTax": "Company income tax",
  "Complete": "Complete",
  "Complete the renovation": "Complete the renovation",
  "Complete the split": "Complete the split",
  "Completed": "Completed",
  "Completion date": "Completion date",
  "Concept": "Concept",
  "Concept mortgage": "Concept mortgage",
  "Construction year": "Construction year",
  "Consult": "Consult",
  "Contact": "Contact",
  "Contact information": "Contact information",
  "Contribution own resources": "Contribution own resources",
  "Cooperation": "Cooperation",
  "Cost buyer": "Cost buyer",
  "Costs": "Costs",
  "Costs buyer": "Costs buyer",
  "Could not reach the assistant. Please try again.": "Could not reach the assistant. Please try again.",
  "Country": "Country",
  "Coverage ratios": "Coverage ratios",
  "Create an arrangement": "Create an arrangement",
  "Create loan part": "Create loan part",
  "Create new building": "Create new building",
  "Create new client": "Create new client",
  "Create new financing": "Create new financing",
  "Create new mortgage": "Create new mortgage",
  "Create new ongoing mortgage": "Create new ongoing mortgage",
  "Create new report": "Create new report",
  "Create new room": "Create new room",
  "Create new scale": "Create new scale",
  "Create new unit": "Create new unit",
  "Create new user": "Create new user",
  "Created": "Created",
  "Created at": "Created at",
  "Credit proposal": "Credit proposal",
  "Critical": "Critical",
  "CryptoCurrency": "Crypto currency",
  "Current mortgage": "Current mortgage",
  "Dashboard": "Dashboard",
  "Date": "Date",
  "Debtors Risk": "Debtors Risk",
  "DebtYieldNetRentResidential": "Debt yield net rent residential",
  "Delete": "Delete",
  "Deny": "Deny",
  "Description": "Description",
  "Details": "Details",
  "Details of the renovation": "Details of the renovation",
  "Did you split this property over multiple buildings?": "Did you split this property over multiple buildings?",
  "Direct check out: loan": "Direct check out: loan",
  "Discount per lender": "Discount per lender",
  "Discount percentage": "Discount percentage",
  "Divide loan over buildings": "Divide loan over buildings",
  "Divide pro rato": "Divide pro rato",
  "Divide purchase value over units": "Divide purchase value over units",
  "Divide renovation costs over units": "Divide renovation costs over units",
  "Divide repayment amount over buildings": "Divide repayment amount over buildings",
  "DividendPayment": "Dividend payment",
  "Do you want a duration shorter or longer than 2 years?": "Do you want a duration shorter or longer than 2 years?",
  "Do you want to finance the renovation costs?": "Do you want to finance the renovation costs?",
  "Document details": "Document details",
  "Document management": "Document management",
  "Document number": "Document number",
  "Document sent": "Document sent",
  "Document type": "Document type",
  "Documents": "Documents",
  "Documents to check": "Documents to check",
  "DocumentsAtTheNotary": "Documents at the notary",
  "DocumentStatusAcceptedByLender": "Accepted by {{name}}",
  "DocumentStatusReceived": "Send to {{name}}",
  "DocumentStatusReceivedByLender": "Sent to {{name}}",
  "DocumentStatusRejected": "Rejected",
  "DocumentStatusRejectedByLender": "Rejected by {{name}}",
  "DocumentStatusRequest": "Request from customer",
  "DocumentStatusRequested": "Requested from customer",
  "Does ... own dutch real estate?": "Does {{value}} owns dutch real estate?",
  "Does repayment apply?": "Does repayment apply?",
  "Done": "Done",
  "Done, continue": "Done, continue",
  "Download": "Download",
  "Download documents": "Download documents",
  "Download report": "Download report",
  "Driver's licence": "Driver's licence",
  "DSCR": "DSCR",
  "DSCR Gross Rent": "DSCR Gross Rent",
  "DSCR Gross Rent Residential": "DSCR Gross Rent Residential",
  "DSCR Net Rent": "DSCR Net Rent",
  "DSCR Net Rent Residential": "DSCR Net Rent Residential",
  "Due Diligence": "Due Diligence",
  "Duration": "Duration",
  "Duration of the renovations": "Duration of the renovations",
  "Dutch": "Dutch",
  "DutchAliensDocument": "Dutch alien's document",
  "DutchAliensIdentityCard": "Dutch alien's identitycard",
  "DutchIdentityCard": "Dutch identitycard",
  "DutchPassport": "Dutch passport",
  "DY": "DY",
  "DY Gross Rent": "DY Gross Rent",
  "DY Gross Rent Residential": "DY Gross Rent Residential",
  "DY Net Rent": "DY Net Rent",
  "DY Net Rent Residential": "DY Net Rent Residential",
  "Edit": "Edit",
  "Edit AVM": "Edit AVM",
  "Edit client": "Edit client",
  "Edit document": "edit document",
  "Edit due diligence fields": "Edit due diligence fields",
  "Edit information": "Edit information",
  "Edit situation fields": "Edit situation fields",
  "Edit valuator": "Edit valuator",
  "Email": "Email",
  "Empty": "Empty",
  "End date": "End date",
  "Energy index": "Energy index",
  "Energy label": "Energy label",
  "English": "English",
  "Enter an address ... owns": "Enter an address {{value}} owns",
  "Enter the address manually": "Enter the address manually",
  "Equal date and duration": "Equal date and duration",
  "Equal start date and duration for all buildings": "Equal start date and duration for all buildings",
  "Error while retrieving portal settings": "Error while retrieving portal settings",
  "Estimated rent": "Estimated rent",
  "Estimated value": "Estimated value",
  "estimated value when rented": "estimated value when rented",
  "Eternally": "Eternally",
  "Excellent": "Excellent",
  "Executed": "Executed",
  "Execution date": "Execution date",
  "Existing client": "Existing client",
  "Expected rent": "Expected rent",
  "Expected rental value after renovation": "Expected rental value after renovation",
  "expected sale value": "expected sale value",
  "Expected sale value": "Expected sale value",
  "Expected sales value": "Expected sales value",
  "Expected value": "Expected value",
  "Expected value after renovation": "Expected value after renovation",
  "Expected value on sale": "Expected value on sale",
  "Expiration date": "Expiration date",
  "Expired": "Expired",
  "Expired on ...": "Expired on {{value}}",
  "Expires": "Expires",
  "Explanation": "Explanation",
  "Explanation of application": "Explanation of application",
  "explanationAccountAlreadyExists": "You cannot create another user with this customer, because an account with this email address already exists. You can create another account from the portal screen and then link this customer to it.",
  "Explanations": "Explanations",
  "Family situation": "Family situation",
  "Featured (max 3)": "Featured (max 3)",
  "Fee for existing clients": "Fee for existing clients",
  "Fee for new clients": "Fee for new clients",
  "Fee type": "Fee type",
  "Fees": "Fees",
  "Female": "Female",
  "Fill in the new addresses": "Fill in the new addresses",
  "Filter": "Filter",
  "Filter results": "Filter results",
  "Finance renovation costs": "Finance renovation costs",
  "Financed at": "Financed at",
  "Financial situation": "Financial situation",
  "Financing expenses": "Financing expenses",
  "Financing information": "Financing information",
  "Financing ratios": "Financing ratios",
  "Financing type": "Financing type",
  "Financing value": "Financing value",
  "Financing value based on": "Financing value based on",
  "Financing value mediation fees": "Financing value mediation fees",
  "Financing with exact loan amount": "Financing with exact loan amount",
  "Financings": "Financings",
  "First name": "First name",
  "FIRST_PAGE_LABEL": "First page",
  "Fixed": "Fixed",
  "for": "for",
  "For how much did you renovate this building?": "For how much did you renovate this building?",
  "For how much money do you want to renovate this building?": "For how much money do you want to renovate this building?",
  "For what amount did you buy this building?": "For what amount did you buy this building?",
  "For what amount do you expect to buy this building?": "For what amount do you expect to buy this building?",
  "Foundation": "Foundation",
  "Founding date": "Founding date",
  "Free cash flow": "Free cash flow",
  "Free sector": "Free sector",
  "from": "from",
  "FromEmployment": "From employment",
  "FromOwnBusiness": "From own business",
  "Full name": "Full name",
  "Garage": "Garage",
  "General": "General",
  "Generate proposals": "Generate proposals",
  "Generating indicative financing proposals.": "Generating indicative financing proposals.",
  "Good": "Good",
  "Good afternoon ...": "Good afternoon {{name}}",
  "Good evening ...": "Good evening {{name}}",
  "Goodmorning ...": "Goodmorning {{name}}",
  "Gross rent": "Gross rent",
  "Gross rent income": "Gross rent income",
  "Gross rental value": "Gross rental value",
  "Ground lease": "Ground lease",
  "Ground lease bought off": "Ground lease bought off",
  "Guarantors": "Guarantors",
  "Handling costs are ...": "Handling costs are {{value}}",
  "has been split!": "has been split!",
  "Has the mortgage already been added?": "Has the mortgage already been added?",
  "Has this building already been financed?": "Has this building already been financed?",
  "Have you purchased this building in the past 12 months?": "Have you purchased this building in the past 12 months?",
  "Have you renovated this building in the past 12 months?": "Have you renovated this building in the past 12 months?",
  "Hello": "Hello",
  "Hide rejections": "Hide rejections",
  "Hide result list": "Hide result list",
  "Highest free cash flow": "Highest free cash flow",
  "Highest loan": "Highest loan",
  "Home": "Home",
  "Hotel": "Hotel",
  "House": "House",
  "House number": "House number",
  "House number addition": "House number addition",
  "Hi {{name}}, how can I help you today?": "Hi {{name}}, how can I help you today?",
  "How can I help you today?": "How can I help you today?",
  "How high is the remaining loan?": "How high is the remaining loan?",
  "How many units will it be?": "How many units will it be?",
  "How much interest do you pay?": "How much interest do you pay?",
  "I already own this building": "I already own this building",
  "I use a fixed fee per financing": "I use a fixed fee per financing",
  "I use a variable fee per financing": "I use a variable fee per financing",
  "I want to buy this building": "I want to buy this building",
  "I want to continue renting out this building": "I want to continue renting out this building",
  "I want to rent out this building": "I want to rent out this building",
  "I want to sell this building": "I want to sell this building",
  "I want to split this building": "I want to split this building",
  "IBAN": "IBAN",
  "ICR": "ICR",
  "ICR Gross Rent": "ICR Gross Rent",
  "ICR Gross Rent Residential": "ICR Gross Rent Residential",
  "ICR Net Rent": "ICR Net Rent",
  "ICR Net Rent Residential": "ICR Net Rent Residential",
  "IcrNetRentAfterRenovation": "ICR net rent after renovation",
  "Identity": "Identity",
  "Identity document": "Identity document",
  "IdentityCardEuOrEaaMemberStateOrSwitzerlandWithPhoto": "Identitycard EU/EAA member state or Switzerland (with photo)",
  "in": "in",
  "In the unlikely event that the permit is not granted, the object can still be used as a single house without another permit (possibly with a small renovation)": "In the unlikely event that the permit is not granted, the object can still be used as a single house without another permit (possibly with a small renovation)",
  "Include invalid": "Include invalid",
  "Included in owners association contribution": "Included in owners association contribution",
  "Information": "Information",
  "Initials": "Initials",
  "InProgress": "In progress",
  "InProgressClosing": "In progress closing",
  "InProgressLoanAgreement": "In progress loan agreement",
  "InProgressTermSheet": "In progress term sheet",
  "InRooms": "In rooms",
  "Insurance": "Insurance",
  "InsurancePolicyPayment": "Insurance policy payment",
  "interest": "interest",
  "Interest": "Interest",
  "Interest amount": "Interest amount",
  "Interest deposit": "Interest deposit",
  "Interest discount": "Interest discount",
  "Interest only": "Aflossingsvrij",
  "Interest period": "Interest period",
  "Interest period in months": "Interest period in months",
  "Interest rate": "Interest rate",
  "Interest rate (min 5 year)": "Interest rate (min 5 year)",
  "Interest rate per year": "Interest rate per year",
  "Into": "Into",
  "Investment": "Investment",
  "Investment plan": "Investment plan",
  "InvestmentWithRenovation": "Investment with renovation",
  "Is ... a company?": "Is {{value}} a company?",
  "is created!": "is created!",
  "is deleted!": "is deleted!",
  "is higher than maximum of": "is higher than maximum of",
  "is lower than minimum of": "is lower than minimum of",
  "Is this building currently rented out?": "Is this building currently rented out?",
  "is updated!": "is updated!",
  "Indexed as": "Indexed as",
  "Issued": "Issued",
  "ITEMS_PER_PAGE_LABEL": "Items per page",
  "LABEL_BUILDING_ACTIONS": "Here you will find promotions that help you create the information. The more complete the information, the more accurate the data in your dashboard and a possible financing request.",
  "LABEL_BUILDING_MORTGAGES": "Current financing influences the return that you make on a property. If you enter them, your adviser can also recalculate your situation in time. Because current loans are sometimes complex, we offer two options.",
  "LABEL_BUILDING_RENOVATIONS": "You can add renovations here that you have done before. This influences your return in the dashboard because you have made more investments in the property than just the purchase. A renovation, when completed here, can also lead to more floor space and other rental income.",
  "LABEL_BUILDING_RENTALCONTRACTS": "You can add rental contracts to a building. When applying for a new loan, a mortgage provider will ask for a rental list. Your adviser can easily provide this on the basis of the data entered here.",
  "LABEL_BUILDING_VALUATIONS": "You can request us to add a valuation report in your administration. This appraisal report is of great importance for future calculations of financing.",
  "LABEL_DESCRIPTION_APPLICATIONS": "Here you can view your open and recently completed applications. You can also request a financing advice.",
  "LABEL_DESCRIPTION_BUILDINGS": "Here you can add, edit and delete your properties. A building is a building with a single address. If a building has several rentable residential units, you can indicate this at the building. Each building will be listed with several icons which will show the current state of the building. The icons are explained below.",
  "LABEL_DESCRIPTION_MORTGAGES": "Here you can add, edit and delete your mortgages",
  "LABEL_DESCRIPTION_RENTALCONTRACTS": "Here you can manage your lease contracts. A rental contract is linked to a property and can contain several tenants.",
  "LABEL_FINANCING_NO_INCOME_OTHER": "Unfortunately, it is not possible to show financing options because the income and obligations of one or more members in the collaboration are unknown.",
  "LABEL_FINANCING_NO_INCOME_PERSON": "To show you the right financing options, you must first fill in the customer's income and liabilities.",
  "LABEL_FINANCING_NO_PROFILE_PERSON": "To show you the right financing options, we need more information on  the customer's investment profile",
  "LABEL_FIRST_PAGE": "First page",
  "LABEL_ITEMS_PER_PAGE": "Items per page",
  "LABEL_LAST_PAGE": "Last page",
  "LABEL_MULTIPLE_LOAN_PARTS": "On this ongoing mortgage multiple loan parts apply, therefore some fields are not adjustable. If you want to change a field, contact your adviser.",
  "LABEL_NEXT_PAGE": "Next page",
  "LABEL_PREVIOUS_PAGE": "Previous page",
  "LABEL_RANGE_PAGE_1": "0 of {{length}}",
  "LABEL_RANGE_PAGE_2": "{{startIndex}} - {{endIndex}} of {{length}}",
  "LABEL_TASK_FINANCINGADVICE_TITLE": "Financing advice",
  "LABEL_TASK_MORTGAGE_BUTTON": "Add my ongoing mortgage",
  "LABEL_TASK_MORTGAGE_COMPLETED": "We've received your request and will add the ongoing mortgage as soon as possible",
  "LABEL_TASK_MORTGAGE_DESCRIPTION": "Upload all relevant documents and we'll add the ongoing financing for you",
  "LABEL_TASK_MORTGAGE_DOCUMENTS": "Most recent annual statement;Loan agreement;",
  "LABEL_TASK_MORTGAGE_HEADER": "Add ongoing mortgage",
  "LABEL_TASK_MORTGAGE_TITLE": "Add ongoing mortgage",
  "LABEL_TASK_VALUATION_BUTTON": "Add my valuation",
  "LABEL_TASK_VALUATION_COMPLETED": "We've received your request and will add the valuation as soon as possible",
  "LABEL_TASK_VALUATION_DESCRIPTION": "Upload all relevant documents and we'll add the valuation for you",
  "LABEL_TASK_VALUATION_DOCUMENTS": "Valuation report",
  "LABEL_TASK_VALUATION_HEADER": "Add valuation",
  "LABEL_TASK_VALUATION_TITLE": "Add valuation",
  "Last requested on ...": "Last requested on {{value}}",
  "LAST_PAGE_LABEL": "Last page",
  "Legal form": "Legal form",
  "Lender": "Lender",
  "Lender accounts": "Lender accounts",
  "Lender commission": "Lender commission",
  "Lender dashboard": "Lender dashboard",
  "Lenders": "Lenders",
  "Let our Unite+ team take care of this application for ...": "Let our Unite+ team take care of this application for {{value}}.",
  "LimitedCompany": "Limited Company",
  "LimitedPartnership": "Limited partnership",
  "Linear": "Linear",
  "Link to application": "Link to application",
  "Link to building": "Link to building",
  "Link to client": "Link to client",
  "Link to mortgage": "Link to mortgage",
  "Linked buildings": "Linked buildings",
  "Linked mortgages": "Linked mortgages",
  "Liquid assets": "Liquid assets",
  "List of buildings": "List of buildings",
  "Loading ...": "Loading ...",
  "Loading buildings": "Panden worden geladen",
  "Loading rental contracts": "Loading rental contracts",
  "Loan": "Loan",
  "Loan amount": "Loan amount",
  "Loan to cost": "Loan to cost",
  "Loan to value": "Loan to value",
  "LoanAgreement": "Loan agreement",
  "LoanAgreementApproved": "Loan agreement approved",
  "LoanAgreementDelivered": "Loan agreement delivered",
  "LoanAgreementInProgress": "Loan agreement in progress",
  "LoanAgreementReceived": "Loan agreement received",
  "LoanAgreementRequested": "Loan agreement requested",
  "LoanProvidedByFinancialInstitution": "Loan provided by financial institution",
  "LoanProvidedByNonFinancialInstitution": "Loan provided by non financial institution",
  "LoanProvidedByOwnCompany": "Loan provided by own company",
  "Location": "Location",
  "Location rating": "Location rating",
  "Login": "Login",
  "Login as advisor": "Login as advisor",
  "Logout": "Logout",
  "Long": "Long",
  "Longer": "Longer",
  "Lowest interest": "Lowest interest",
  "Lowest own contribution": "Lowest own contribution",
  "LTV": "LTV",
  "Maintenance": "Maintenance",
  "Manage new units": "Manage new units",
  "Management": "Management",
  "Manual points": "Manual points",
  "Marital status": "Marital status",
  "Market rent": "Market rent",
  "Market value": "Market value",
  "MarriedCommunityProperty": "Married in community property",
  "MarriedPrenup": "Married with prenuptial agreement",
  "Max theoretical space": "Max theoretical space",
  "Maximum": "Maximum",
  "Maximum additional income": "Maximum additional income",
  "Maximum fee": "Maximum fee",
  "Maximum fee per financing": "Maximum fee per financing",
  "Maximum financing amount": "Maximum financing amount",
  "Maximum loan": "Maximum loan",
  "Maximum loan after 1 Year": "Maximum loan after 1 Year",
  "Maximum loan after renovation": "Maximum loan after renovation",
  "MaximumLoan": "Maximum loan",
  "Mediation fees": "Mediation fees",
  "Members": "Members",
  "Messages": "Messages",
  "Middle name": "Middle name",
  "Minimal ... is ...": "Minimal {{ property }} is {{ value }}",
  "Minimum": "Minimum",
  "Minimum fee": "Minimum fee",
  "Minimum financing amount": "Minimum financing amount",
  "Minimum repayment rate": "Minimum repayment rate",
  "MinimumLoan": "Minimum loan",
  "Missing documents": "Missing documents",
  "Miximal ... is ...": "Maximal {{ property }} is {{ value }}",
  "Mobile": "Mobile",
  "Moderate": "Moderate",
  "Modified at": "Modified at",
  "MoneyTransfer": "Money transfer",
  "Monthly": "Monthly",
  "Monthly payment is ... and consists out of": "Monthly payment is <strong>{{value}}</strong> and consists out of",
  "months": "months",
  "Months": "Months",
  "More information": "More information",
  "Mortgage": "Mortgage",
  "Mortgage amount": "Mortgage amount",
  "Mortgage details": "Mortgage details",
  "Mortgage documents": "Mortgage documents",
  "Mortgage number": "Mortgage number",
  "MortgageDeedDraft": "Mortgage deed draft",
  "MortgagePassed": "Mortgage passed",
  "mortgages": "mortgages",
  "Mortgages": "Mortgages",
  "Mr.": "Mr.",
  "Mrs.": "Mrs.",
  "Name": "Name",
  "Name of the room": "Name of the room",
  "Name of the unit": "Name of the unit",
  "Name of the unit: ": "Name of the unit: ",
  "Nationality": "Nationality",
  "Net initial yield": "Net initial yield",
  "Net rent": "Net rent",
  "Net rent income": "Net rent income",
  "Net rental value": "Net rental value",
  "New": "New",
  "New application": "New application",
  "New building": "New building",
  "New conversation": "New conversation",
  "Recent conversations": "Recent conversations",
  "No conversations yet": "No conversations yet",
  "Conversation": "Conversation",
  "Documents for your attention": "Documents for your attention",
  "For your attention": "For your attention",
  "Waiting for your answer": "Waiting for your answer",
  "Finished": "Finished",
  "In progress": "In progress",
  "The assistant is working on this document…": "The assistant is working on this document…",
  "Delete conversation": "Delete conversation",
  "New financing": "New financing",
  "New mortgage": "New mortgage",
  "New ongoing mortgage": "New ongoing mortgage",
  "New room": "New room",
  "New unit": "New unit",
  "Next building": "Next building",
  "Next step": "Next step",
  "NEXT_PAGE_LABEL": "Next page",
  "No": "No",
  "No actions found. Good job!": "No actions found. Good job!",
  "No arrangements found": "No arrangements found",
  "No automated value models found": "No automated value models found",
  "No mortgages found": "No mortgages found",
  "No ongoing renovation found": "No ongoing renovation found",
  "No renovation records submitted yet.": "No renovation records submitted yet.",
  "No scales found": "No scales found",
  "No tenants found": "No tenants found",
  "No users found": "No users found",
  "No valid input": "No valid input",
  "No valuation records submitted yet.": "No valuation records submitted yet.",
  "No valuators found": "No valuators found",
  "No value found": "No value found",
  "Non-linked": "Non-linked",
  "Non-linked documents": "Non-linked documents",
  "None": "None",
  "NonResidential": "Non residential",
  "Not": "Not",
  "Not linked": "Not linked",
  "Not observed": "Not observed",
  "Not rated": "Not rated",
  "Not recognised, please categorize the document": "Not recognised, please categorize the document",
  "Notary fees": "Notary fees",
  "Nothing found": "Nothing found",
  "Number": "Number",
  "Number of buildings": "Number of buildings",
  "Number of potential tenants": "Number of potential tenants",
  "Number of rooms": "Number of rooms",
  "Number of the mortgage": "Number of the mortgage",
  "Number of units": "Number of units",
  "Numbers": "Numbers",
  "Object rating": "Object rating",
  "Office": "Office",
  "Offices": "Offices",
  "OK": "OK",
  "on": "on",
  "Ongoing mortgages": "Ongoing mortgages",
  "Only residential": "Only residential",
  "Only the statuses purchase and owned will be included": "Only the statuses purchase and owned will be included",
  "Open Unite Assistant": "Open Unite Assistant",
  "Operating costs": "Operating costs",
  "Operating costs per year": "Operating costs per year",
  "Organization": "Organization",
  "Origin own resources": "Origin own resources",
  "Other": "Other",
  "Other costs": "Other costs",
  "Other deposit": "Other deposit",
  "Overview": "Overview",
  "Own contribution": "Own contribution",
  "Own contribution:": "Own contribution:",
  "Owned": "Owned",
  "Owners association": "Owners association",
  "Owners association contribution": "Owners association contribution",
  "Owners description": "Owners description",
  "OwnsHouse": "Own house",
  "OwnUse": "Own use",
  "p/m": "p/m",
  "Parking": "Parking",
  "Particularities": "Particularities",
  "Partnership": "Partnership",
  "PartnershipUnderFirm": "Partnership under firm",
  "Passport": "Passport",
  "PassportCountryOfOrigin": "Passport country of origin",
  "Password reset email sent": "Wachtwoord opnieuw instellen e-mail verstuurd",
  "Payment details2": "Payment details",
  "Penalty": "Penalty",
  "Penalty Interest": "Penalty Interest",
  "Pending applications": "Pending applications",
  "per month": "per month",
  "per year": "per year",
  "Percentage": "Percentage",
  "Period in months": "Period in months",
  "Permits available": "Permits available",
  "Permits requested": "Permits requested",
  "Permits required": "Permits required",
  "Person": "Person",
  "Personal information": "Personal information",
  "please check": "please check",
  "Please select a file that is smaller than 1 mb": "Please select a file that is smaller than 1 mb",
  "Please select a file with the .jpg or .png extension": "Please select a file with the .jpg or .png extension",
  "Points rent": "Points rent",
  "Possibly": "Possibly",
  "Postalcode": "Postalcode",
  "Practice space": "Practice space",
  "PracticeSpace": "Practice space",
  "Preview": "Preview",
  "Previous building": "Previous building",
  "PREVIOUS_PAGE_LABEL": "Previous page",
  "Prior renovation": "Prior renovation",
  "PrivateCompany": "Private company",
  "PrizeMoney": "Prize money",
  "Pro rato loan": "Pro rato loan",
  "Product": "Product",
  "Profession": "Profession",
  "Properties": "Properties",
  "Proposal": "Proposal",
  "Proposal information": "Proposal information",
  "Proposals": "Proposals",
  "Provision": "Provision",
  "Provisional energy label": "Provisional energy label",
  "Purchase": "Purchase",
  "Purchase date": "Purchase date",
  "Purchase price": "Purchase price",
  "Purchase protection act applies in ... for homes with a max estimated value by municipality of ...": "Purchase protection act applies in {{area}} for homes with a max estimated value by municipality of {{max}}",
  "Purchase sum": "Purchase price",
  "purchase value": "purchase value",
  "Purchase value": "Purchase value",
  "Purchase value pro rata": "Purchase value pro rata",
  "PurchaseValue": "Purchase value",
  "PurchaseValueIncludingCosts": "Purchase value including costs",
  "PurchaseValueIncludingCostsAndRenovation": "Purchase value including costs and renovation",
  "Purpose": "Purpose",
  "RANGE_PAGE_LABEL_1": "0 of {{length}}",
  "RANGE_PAGE_LABEL_2": "{{startIndex}} - {{endIndex}} of {{length}}",
  "Rate": "Rate",
  "Rate per year": "Rate per year",
  "Real estate portfolio": "Real estate portfolio",
  "Real estate tax": "Real estate tax",
  "Real estate value": "Real estate value",
  "Real estate value based on": "Real estate value based on",
  "RealEstate": "Real estate",
  "Realization risk": "Realization risk",
  "Reasonable": "Reasonable",
  "Reasonable to good": "Reasonable to good",
  "Recalculate": "Recalculate",
  "ReceivedByLender": "Sent to lender",
  "Recognised as": "Recognised as",
  "Recognised automatically, please check the values": "Recognised automatically, please check the values",
  "Redirect not found": "Redirect not found",
  "Redirecting you to the application": "Redirecting you to the application",
  "Reference date": "Reference date",
  "Refinance": "Refinance",
  "Refinance mortgages": "Refinance mortgages",
  "Refinance penalty": "Refinance penalty",
  "Refinancing amount": "Refinancing amount",
  "Refinancing penalty interest": "Refinancing penalty interest",
  "RegisteredPartnership community property": "Registered partnership with community property",
  "RegisteredPartnership prenup": "Registered partnership with prenuptial agreement",
  "RegisteredPartnershipCommunityProperty": "Registered partnership with community property",
  "RegisteredPartnershipPrenup": "Registered partnership with prenuptial agreement",
  "Rejected": "Rejected",
  "RejectedByLender": "Rejected by lender",
  "Rejections": "Rejections",
  "Relation with real estate": "Relation with real estate",
  "Remove attachment": "Remove attachment",
  "Remove guarantor": "Remove guarantor",
  "Renovation": "Renovation",
  "Renovation costs": "Renovation costs",
  "Renovation costs pro rata": "Renovation costs pro rato",
  "Renovation date": "Renovation date",
  "Renovation included": "Renovation included",
  "Renovations": "Renovations",
  "Rent": "Rent",
  "Rent income": "Rent income",
  "Rentability": "Rentability",
  "Rental points": "Rental points",
  "Rental value": "Rental value",
  "Rental value after renovation": "Rental value after renovation",
  "RentalToFamily": "Rental to family",
  "Rented": "Rented",
  "RentsHouse": "Rents house",
  "repayment": "repayment",
  "Repayed": "Repaid",
  "Repayment": "Repayment",
  "Repayment (annually)": "Repayment (annually)",
  "Repayment amount": "Repayment amount",
  "Repayment existing mortgage": "Repayment existing mortgage",
  "Repayment free from LTV": "Repayment free from LTV",
  "Repayment rate": "Repayment rate",
  "Repayment required": "Repayment required",
  "RepaymentFree": "Repayment free",
  "RepaymentFreeAndAnnuity": "Annuity + {{value}}% repayment free",
  "RepaymentFreeAndLinear": "Linear + {{value}}% repayment free",
  "ReportBox3Analysis": "Box 3 analysis report",
  "ReportBox3AnalysisDescription": "The Box 3 report calculates tax differences between the old regime and the transitional regime, and displays the breakdown of the tax amount. It also determines the empty value ratio and the fiscal value per property. Customers can input values for savings, other assets, and debts to obtain a more accurate tax amount.",
  "ReportBox3AnalysisTitle": "Box 3 analysis report",
  "ReportBox3AnalysisTitleDescription": "This report calculates the difference in tax amount between the old Box 3 regime and the transitional regime.",
  "ReportBusinessPlanAnalysis": "Business plan analysis report",
  "ReportBusinessPlanAnalysisDescription": "The report 'Business Plan' is designed for real estate investors and provides insights into their current situation and future plans to maximize the return on their real estate portfolio. This analysis also maps out the cash flow per property and shows whether it is feasible to positively influence this cash flow by adjusting the energy label. Based on all the calculated values, the client can input the desired scenario for each property, ultimately creating a business plan for the future.",
  "ReportBusinessPlanAnalysisTitle": "Business plan analysis report",
  "ReportBusinessPlanAnalysisTitleDescription": "The latest report in Unite leads to an action plan, where the impact of both Box 3, the planned Middle Rental Scheme, and rising interest rates are visualized for each property.",
  "ReportMidRentAnalysis": "Mid rent analysis report",
  "ReportMidRentAnalysisDescription": "Currently, some homes are still in the free sector, allowing you to determine the rent price yourself. However, starting from 2024, a portion of the free sector will transition to mid-rent, which may result in a decrease in rental income. In this report, you can find information on the impact of this change and how to prevent potential rent decrease by adjusting the energy label, for example. The report indicates for each property whether it falls within the social sector, mid-rent, or free sector now and after 2024, and which energy label can be adjusted to increase the rent and enhance the value of your portfolio.",
  "ReportMidRentAnalysisTitle": "Mid rent analysis report",
  "ReportMidRentAnalysisTitleDescription": "This report shows the difference in rental income resulting from the proposed plans for mid-range rental properties as of 1-1-2024, including the impact that upgrading to a higher energy label would have on rental revenue.",
  "ReportPurchaseAnalysis": "Purchase analysis report",
  "ReportPurchaseAnalysisDescription": "The calculation of the achievable return is becoming increasingly complex due to the current changes. This report calculates all relevant ratios and returns, such as BAR, NAR, ROE and ROI, for the intended purchase of one or more properties. It takes into account the effects both without and with the mid-rental plans and revised BOX 3 regulations, along with current interest rates. And if you input a desired return, the maximum investment will be calculated.",
  "ReportPurchaseAnalysisTitle": "Purchase analysis report",
  "ReportPurchaseAnalysisTitleDescription": "This report shows the return on investment for the intended purchase of one or more properties, taking into account current laws and regulations, including upcoming changes.",
  "ReportRefinancingAnalysis": "Refinancing analysis report",
  "ReportRefinancingAnalysisDescription": "The interest rate that an investor pays has a significant impact on the investor's financial situation. When the fixed interest rate period of a loan expires, the financing costs can change considerably. This report illustrates the maximum amount that can be borrowed and the effect of an interest rate change on the cash flow. The calculated financing is determined through a real-time comparison of rates, current interest rates, and repayment conditions from almost all lenders in the Netherlands.",
  "ReportRefinancingAnalysisTitle": "Refinancing analysis report",
  "ReportRefinancingAnalysisTitleDescription": "This report analyzes the effect of an interest rate change on the cash flow, based on a calculation for refinancing",
  "ReportStructuralRiskAnalysis": "Structural risk analysis report",
  "ReportStructuralRiskAnalysisDescription": "If an investor owns various financiers and/or different types of collateral, a structural risk arises. The stance of one financier can influence the position of another financier, which is why it is important to be aware of this risk. This report maps out which (type of) properties are owned, along with their corresponding rental income. The current financing arrangements from different financiers are then linked to the properties. The outstanding principal amounts, interest, repayment, and expiration date of the fixed interest period are processed in the report for the current financings. Ratios such as DSCR, ICR, and LLD are thereby made visible at a glance and can be filtered based on various parameters such as property type, lender, or financing, if desired.",
  "ReportStructuralRiskAnalysisTitle": "Structural risk analysis report",
  "ReportStructuralRiskAnalysisTitleDescription": "This report provides visibility into ratios such as DSCR, ICR, and LLD, allowing for a straightforward assessment of structural risk in case of multiple financings with different lenders.",
  "Resend verification email": "Resend verification email",
  "Reset": "Reset",
  "Reset filters": "Reset filters",
  "Reset password": "Send password reset email",
  "Retry": "Retry",
  "Residential": "Residential",
  "Restaurant": "Restaurant",
  "Result": "Result",
  "RET": "Real estate tax",
  "Retrieving ... addresses": "Retrieving {{value}} addresses",
  "Retrieving your data": "Retrieving your data",
  "Return on equity": "Return on equity",
  "Return on investment": "Return on investment",
  "Return to financing": "Return to financing",
  "Revenue": "Revenue",
  "ROE": "ROE",
  "ROI": "ROI",
  "Room 1": "Room 1",
  "Room rental": "Room rental",
  "Rooms": "Rooms",
  "Saleability": "Saleability",
  "SaleOfInvestments": "Sale of investments",
  "SaleOfProperty": "Sale of property",
  "Save": "Save",
  "Save ... changes": "Save {{value}} changes",
  "Save ... collaborations": "Save {{value}} collaborations",
  "Save all ... buildings": "Alle {{value}} panden opslaan",
  "Save arrangement": "Save arrangement",
  "Save AVM": "Save AVM",
  "Save building": "Save building",
  "Save collaboration": "Save collaboration",
  "Save company": "Save company",
  "Save fee settings": "Save fee settings",
  "Save mortgage": "Save mortgage",
  "Save ongoing mortgage": "Save ongoing mortgage",
  "Save person": "Save person",
  "Save valuator": "Save valuator",
  "Saved!": "Saved!",
  "Screensharing": "Screensharing",
  "Search for a person": "Search for a person",
  "Search for a person or company": "Search for a person or company",
  "Search for client, property, mortgage": "Search for client, property, mortgage",
  "Select a document": "Select a document",
  "Select file": "Select file",
  "Select the buildings to which this mortgage is linked": "Select the buildings to which this mortgage is linked",
  "Select the owner that matches ...": "Select the owner that matches {{value}}",
  "Select the related buildings": "Select the related buildings",
  "Selected buildings": "Selected buildings",
  "Sell": "Sell",
  "SellOff": "Sell off",
  "Send": "Send",
  "Send additional information": "Send additional informatio",
  "Set to Dutch": "Set to Dutch",
  "Set to English": "Set to English",
  "Settings": "Settings",
  "Sewage charges": "Sewage charges",
  "Share": "Share",
  "Share:": "Share:",
  "Shareholder of": "Shareholder of",
  "Shareholders": "Shareholders",
  "Short": "Short",
  "Shorter": "Shorter",
  "Show all rejections": "Show all rejections",
  "Show all results": "Show all results",
  "Show more": "Show more",
  "Show screen sharing code": "Show screen sharing code",
  "Single": "Single",
  "Situation": "Situation",
  "Sold": "Sold",
  "SoleProprietorship": "Sole Proprietorship",
  "Something else…": "Something else…",
  "Something went wrong": "Something went wrong",
  "Sort by": "Sort by",
  "Specific loan amount": "Specific loan amount",
  "Specifications": "Specifications",
  "Specifications mortgage": "Specifications mortgage",
  "Specified": "Specified",
  "Split": "Split",
  "Split costs": "Split costs",
  "Split costs pro rata": "Split costs pro rata",
  "Start": "Start",
  "Start date": "Start date",
  "Start new finance": "Start new finance",
  "Starting this VIR session will result in high data costs (€...)": "Starting this VIR session will result in high data costs (€ {{value}})",
  "Status": "Status",
  "Statutory location": "Statutory location",
  "Stop": "Stop",
  "Store": "Store",
  "Stores": "Stores",
  "Street": "Street",
  "Studio": "Studio",
  "Submit renovation": "Submit renovation",
  "Submit valuation": "Submit valuation",
  "SubmitErrorAddress is missing": "Address is missing",
  "SubmitErrorAddress line 1 is missing": "Address line 1 is missing",
  "SubmitErrorApplicant address country is missing": "Applicant address country is missing",
  "SubmitErrorApplicant contact birthdate is missing": "Applicant contact birthdate is missing",
  "SubmitErrorApplicant contact emailaddress is missing": "Applicant contact emailaddress is missing",
  "SubmitErrorApplicant contact initials are missing": "Applicant contact initials are missing",
  "SubmitErrorApplicant contact is missing": "Applicant contact is missing",
  "SubmitErrorApplicant contact phone is missing": "Applicant contact phone is missing",
  "SubmitErrorApplicant contact surname is missing": "Applicant contact surname is missing",
  "SubmitErrorApplicant emailaddress is missing": "Applicant emailaddress is missing",
  "SubmitErrorApplicant emailaddress tax partner is missing": "Applicant emailaddress tax partner is missing",
  "SubmitErrorApplicant founding date is missing": "Applicant founding date is missing",
  "SubmitErrorApplicant investment profile is missing": "Applicant investment profile is missing",
  "SubmitErrorApplicant legal form is missing": "Applicant legal form is missing",
  "SubmitErrorApplicant marital status is missing": "Applicant marital status is missing",
  "SubmitErrorApplicant nationality is missing": "Applicant nationality is missing",
  "SubmitErrorApplicant phone is missing": "Applicant phone is missing",
  "SubmitErrorApplicant statutory location is missing": "Applicant statutory location is missing",
  "SubmitErrorApplicant statutory name is missing": "Applicant statutory name is missing",
  "SubmitErrorApplicant tax partner is missing": "Applicant tax partner is missing",
  "SubmitErrorBorrower address country is missing": "Borrower address country is missing",
  "SubmitErrorBorrower contact is missing": "Borrower contact is missing",
  "SubmitErrorBorrower emailaddress is missing": "Borrower emailaddress is missing",
  "SubmitErrorBorrower emailaddress tax partner is missing": "Borrower emailaddress tax partner is missing",
  "SubmitErrorBorrower founding date is missing": "Borrower founding date is missing",
  "SubmitErrorBorrower investment profile is missing": "Borrower investment profile is missing",
  "SubmitErrorBorrower legal form is missing": "Borrower legal form is missing",
  "SubmitErrorBorrower marital status is missing": "Borrower marital status is missing",
  "SubmitErrorBorrower nationality is missing": "Borrower nationality is missing",
  "SubmitErrorBorrower phone is missing": "Borrower phone is missing",
  "SubmitErrorBorrower statutory location is missing": "Borrower statutory location is missing",
  "SubmitErrorBorrower statutory name is missing": "Borrower statutory name is missing",
  "SubmitErrorBorrower tax partner is missing": "Borrower tax partner is missing",
  "SubmitErrorChamber of commerce nummer is missing": "Chamber of commerce nummer is missing",
  "SubmitErrorContact Birthdate is missing": "Contact Birthdate is missing",
  "SubmitErrorContact Phone number is missing": "Contact Phone number is missing",
  "SubmitErrorException while validating the application": "Exception while validating the application",
  "SubmitErrorGuarantor address country is missing": "Guarantor address country is missing",
  "SubmitErrorGuarantor emailaddress is missing": "Guarantor emailaddress is missing",
  "SubmitErrorGuarantor is not a natural person": "Guarantor is not a natural person",
  "SubmitErrorGuarantor marital status is missing": "Guarantor marital status is missing",
  "SubmitErrorGuarantor nationality is missing": "Guarantor nationality is missing",
  "SubmitErrorGuarantor phone is missing": "Guarantor phone is missing",
  "SubmitErrorPurchase date is missing": "Purchase date is missing",
  "SubmitErrorPurchase value is missing": "Purchase value is missing",
  "SubmitErrorRenovation executed by (main)contractor is missing": "Renovation executed by (main)contractor is missing",
  "SubmitErrorRented is missing": "Rented is missing",
  "SubmitErrorSublet is unknown": "Sublet is unknown",
  "SubmitErrorUbo address country is missing": "UBO address country is missing",
  "SubmitErrorUbo address is missing": "UBO address is missing",
  "SubmitErrorUbo emailaddress is missing": "UBO emailaddress is missing",
  "SubmitErrorUbo marital status is missing": "UBO marital status is missing",
  "SubmitErrorUbo nationality is missing": "UBO nationality is missing",
  "SubmitErrorUbo phone is missing": "UBO phone is missing",
  "Subscription": "Subscription",
  "Successfully uploaded your logo": "Successfully uploaded your logo",
  "Suggested automatically, please check the values before saving": "Suggested automatically, please check the values before saving",
  "Summary": "Summary",
  "Supported logo format": "Currently we only support files smaller than 1mb and with the .png or .jpg extension",
  "Surface": "Surface",
  "Surface after renovation": "Surface after renovation",
  "Surface of the room": "Surface of the room",
  "Surface of the unit": "Surface of the unit",
  "Surname": "Surname",
  "Take": "Take",
  "Telephone": "Telephone",
  "Temporarily": "Temporarily",
  "TermSheet": "Term sheet",
  "TermSheetApproved": "Term sheet approved",
  "TermSheetDelivered": "Term sheet delivered",
  "TermSheetInProgress": "Term sheet in progress",
  "TermSheetReceived": "Term sheet received",
  "TermSheetRequested": "Term sheet requested",
  "The arrangement": "The arrangement",
  "The assistant needs access to": "The assistant needs access to",
  "The assistant wants to call": "The assistant wants to call",
  "The browser is reloading due to inactivity.": "The browser is reloading due to inactivity.",
  "The browser will reload": "The browser will reload",
  "The closing commission means that ... less is available for a purchase or refinancing.": "The closing commission means that <strong>{{value}}</strong> less is available for a purchase or refinancing.",
  "The following fields need to be changed:": "The following fields need to be changed:",
  "The interest deposit means that ... less is available for a purchase or refinancing.": "The interest deposit means that <strong>{{value}}</strong> less is available for a purchase or refinancing.",
  "The lender offers a compensation of ... for all costs that the investor has to incur.": "The lender offers a compensation of <strong>{{value}}</strong> for all costs that the investor has to incur.",
  "the lender offers a interest discount of ...% during the fixed-interest period.": "the lender offers a interest discount of <strong>{{value}}%</strong> during the fixed-interest period.",
  "The maximum fee, there is no max when you leave the field empty": "The maximum fee, there is no max when you leave the field empty",
  "The maximum loan is limited because the rent of ... is maximized by the points rental system.": "The maximum loan is limited because the rent of {{ value }} is maximized by the points rental system.",
  "The maximum of ... cadastral information hits within ... hours has been reached. Please enter other owned addresses manually.": "The maximum of {{ max }} cadastral information hits within {{ hours }} hours has been reached. Please enter other owned addresses manually.",
  "The maximum rent according to the points system (home valuation system) is ... . As a result, the house does not fall into the private sector. The lender will therefore not calculate the rental income, but this limited rent.": "The maximum rent according to the points system (home valuation system) is {{value}}. As a result, the house does not fall into the private sector. The lender will therefore not calculate the rental income, but this limited rent.",
  "The minimum fee": "The minimum fee",
  "The moment the loan is less than ... of the value, the repayment obligation lapses and only interest is due.": "The moment the loan is less than {{ value }}% of the value, the repayment obligation lapses and only interest is due.",
  "The recognised document type and dates are correct": "The recognised document type and dates are correct",
  "The server is unreachable. Please try again in a few minutes": "The server is unreachable. Please try again in a few minutes",
  "The user has not sufficient permissions for this action": "The user has not sufficient permissions for this action",
  "The user is not authorized": "The user is not authorized",
  "The user will receive an email on '...'. The user than needs to verify the email and choose a password.": "The user will receive an email on '{{value}}'. The user than needs to verify the email and choose a password.",
  "Theoretical space": "Theoretical space",
  "There are no rejections found.": "There are no rejections found.",
  "There are no suitable proposals found that meets your demands.": "There are no suitable proposals found that meets your demands.",
  "There are no suitable proposals found.": "There are no suitable proposals found.",
  "There is an update available. Do you want to update?": "There is an update available. Do you want to update?",
  "These units will be created and the parent building will be deleted.": "These units will be created and the parent building will be deleted.",
  "This ... is being renovated": "This {{value}} is being renovated",
  "This ... is being rented": "This {{value}} is being rented",
  "This ... is being split from the": "This {{value}} is being split from the",
  "This ... is part of the building": "This {{value}} is part of the building",
  "This ... will be split into new units": "This {{value}} will be split into new units",
  "This address has a different owner than ...": "This address has a different owner than {{ value }}",
  "This building is not financed": "This building is not financed",
  "This can take a while if you have multiple buildings": "This can take a while if you have multiple buildings",
  "This is not a valid address": "This is not a valid address",
  "This is the penalty interest based on the current interest rate of ... (...%)": "This is the penalty interest based on the current interest rate ({{newInterestRate}}%) of {{ newInterestProductDescription}}",
  "This loan is subject to a closing fee of ...%.": "This loan is subject to a closing fee of <strong>{{value}}%</strong>.",
  "This means you only pay ...% interest monthly and you can often borrow more.": "This means you only pay <strong>{{value}}%</strong> interest monthly and you can often borrow more.",
  "this mortgage": "this mortgage",
  "this renovation": "this renovation",
  "this valuation": "this valuation",
  "To": "To",
  "Tool approval required": "Tool approval required",
  "Total": "Total",
  "total collateral value": "total collateral value",
  "Total financing needs": "Total financing needs",
  "Total investment": "Total investment",
  "Total loan": "Total loan",
  "Total mortgage amount": "Total mortgage amount",
  "Total operating costs": "Total operating costs",
  "Total points": "Total points",
  "Total purchase investment": "Total purchase investment",
  "Total real estate value": "Total real estate value",
  "Total renovation costs:": "Total renovation costs:",
  "Total rental value": "Total rental value",
  "Total repayment per year": "Total repayment per year",
  "Total value in rented condition": "Total value in rented condition",
  "Trackrecord": "Trackrecord",
  "Trade": "Trade",
  "Transfer tax": "Transfer tax",
  "Transformation": "Transformation",
  "Transformed": "Transformed",
  "Type": "Type",
  "Type summary here": "Type summary here",
  "Type your message…": "Type your message…",
  "Under construction": "Under construction 👷‍♂️",
  "Unite Assistant": "Unite Assistant",
  "Units": "Units",
  "Upload document": "Upload document",
  "Upload document for this application": "Upload document for this application",
  "Upload document for this building": "Upload document for this building",
  "Upload document for this collaboration": "Upload document for this collaboration",
  "Upload document for this company": "Upload document for this company",
  "Upload document for this mortgage": "Upload document for this mortgage",
  "Upload document for this person": "Upload document for this person",
  "Upload failed": "Upload failed",
  "Upload logo": "Upload your logo. ",
  "Upload progress": "Uploading progress",
  "Upload the file again": "Upload the file again",
  "Upload year": "Upload year",
  "Uploading documents": "Uploading files",
  "User deleted": "User deleted",
  "Users": "Users",
  "Vacancy risk": "Vacancy risk",
  "Valuated by ... on ...": "Valuated by {{valuator}} on {{date}}",
  "Valuation costs": "Valuation costs",
  "Valuation history": "Valuation history",
  "Valuation report": "Valuation report",
  "Valuator": "Valuator",
  "Valuator added": "Valuator added",
  "Valuators": "Valuators",
  "Value after renovation": "Value after renovation",
  "Value collateral": "Value collateral",
  "value in rented condition": "value in rented condition",
  "Value in rented condition": "Value in rented condition",
  "Value in rented condition after renovation": "Value in rented condition after renovation",
  "Value vacant": "Value vacant",
  "Value vacant after renovation": "Value vacant after renovation",
  "ValueInRentedCondition": "Value in rented condition",
  "ValueInRentedConditionAfterRenovation": "Value in rented condition after renovation",
  "ValueVacant": "Value vacant",
  "ValueVacantAfterRenovation": "Value vacant after renovation",
  "Variable": "Variable",
  "Verification email sent": "Verificatie e-mail verstuurd",
  "Version": "Version",
  "Very bad": "Very bad",
  "Very good": "Very good",
  "View all": "View all",
  "View all applications": "View all applications",
  "View all buildings": "View all buildings",
  "View all clients": "View all clients",
  "View all financings": "View all financings",
  "View all mortgages": "View all mortgages",
  "View client details": "View client details",
  "View details": "View details",
  "View financing": "View financing",
  "View history": "View history",
  "View list": "View list",
  "WaitForExecution": "Wait for execution",
  "Waiting for authorization in popup…": "Waiting for authorization in popup…",
  "Waiting for final offer from ...": "Waiting for final offer from {{value}}",
  "Waiting for indicative offer from ...": "Waiting for indicative offer from {{value}}",
  "WaitingForLoanAdjustments": "Waiting for loan adjustments",
  "WaitingForLoanAgreementDocuments": "Waiting for loan agreement documents",
  "WaitingForTermSheetDocuments": "Waiting for term sheet documents",
  "WaitingForValuation": "Waiting for valuation",
  "Warning": "Warning",
  "Water authority tax": "Water authority tax",
  "We are creating your application: ... 🚀!": "We are creating your application: {{value}} 🚀!",
  "We could not find the account": "We could not find the account",
  "Welcome ...": "Welcome {{name}}",
  "WELCOME_INTRO": "You can start off by entering a customer and a building he or she would like to finance. After this you can calculate indicative financing proposals and download an application form. In this video you can watch how you can create your first application form. If you need more help you can read our <a href='https://unite.nl/faq/'>frequently asked questions</a> or contact us.",
  "WELCOME_TITLE": "Welcome to Unite!",
  "What applies to this building?": "What applies to this building?",
  "What are you planning to do with this building?": "What are you planning to do with this building?",
  "What is the address of the new building?": "What is the address of the new building?",
  "What is the current value prior renovation?": "What is the current value prior renovation?",
  "What is the expected rent income after renovation?": "What is the expected rent income (excl. operating costs) after renovation?",
  "What is the expected rent income and number of potential tenants after renovation?": "What is the expected rent income (excl. operating costs) and number of potential tenants after renovation?",
  "What is the expected rent income and number of potential tenants?": "What is the expected rent income (excl. operating costs) and number of potential tenants?",
  "What is the expected rent income?": "What is the expected rent income (excl. operating costs)?",
  "What is the expected sales value after renovation?": "What is the expected sales value after renovation?",
  "What is the expected sales value?": "What is the expected sales value?",
  "What is the mortgage number and how high is the remaining loan?": "What is the mortgage number and how high is the remaining loan?",
  "What is the rent income and number of potential tenants?": "What is the rent income (excl. operating costs) and number of potential tenants?",
  "What is the start date and duration of the finance?": "What is the start date and duration of the finance?",
  "What is the start date and duration of this building?": "What is the start date and duration of this building?",
  "What is your current mortgage for this building?": "What is your current mortgage for this building?",
  "What type of building is this?": "What type of building is this?",
  "What type of building will it be?": "What type of building will it be?",
  "When did the renovation start and how long does it take?": "When did the renovation start and how long does it take?",
  "When will the renovation start and how long will it take?": "When will the renovation start and how long will it take?",
  "Which lender is supplying this mortgage?": "Which lender is supplying this mortgage?",
  "Widowed": "Widowed",
  "Will be renovated": "Will be renovated",
  "Will the building be transformed into another type? (e.g. office to home)": "Will the building be transformed into another type? (e.g. office to home)",
  "With existing clients": "With existing clients",
  "Within ... days": "Within {{value}} days",
  "With new clients": "With new clients",
  "WOZ-value": "WOZ-value",
  "Writing": "Writing",
  "WritingAdvisoryReport": "Writing advisory report",
  "Year": "Year",
  "Year ...": "Year {{value}}",
  "Years": "Years",
  "Yes": "Yes",
  "You already own this building": "You already own this building",
  "You are going to buy this building on": "You are going to buy this building on",
  "Your code is: ": "Your code is: ",
  "Your generated financing proposals": "Your generated financing proposals",
  "Your logo": "Your logo",
  "Your mortgages": "Your mortgages",
  "Your organization": "Your organization",
  "Admin settings": "Admin settings",
  "Only a super admin can open the admin settings": "Only a super admin can open the admin settings",
  "Add lender": "Add lender",
  "Edit lender": "Edit lender",
  "Save lender": "Save lender",
  "Lender created": "Lender created",
  "No lenders found": "No lenders found",
  "Hidden": "Hidden",
  "A hidden lender can no longer be selected": "A hidden lender can no longer be selected",
  "The lender number in the calculation service (0: none)": "The lender number in the calculation service (0: none)",
  "Appointment email": "Appointment email",
  "Financing email": "Financing email",
  "Alternative names": "Alternative names",
  "One name per line, used to recognize the lender in documents": "One name per line, used to recognize the lender in documents",
  "Hidden: the lender can no longer be selected": "Hidden: the lender can no longer be selected",
  "Rates": "Rates",
  "Add rate": "Add rate",
  "Edit rate": "Edit rate",
  "Save rate": "Save rate",
  "Rate added": "Rate added",
  "No rates found": "No rates found",
  "Portal product": "Portal product",
  "Not through the portal": "Not through the portal",
  "Applications with this rate are submitted through the lender's portal as this product": "Applications with this rate are submitted through the lender's portal as this product",
  "Product name": "Product name",
  "Consumers only": "Consumers only",
  "Custom": "Custom",
  "Added by a user, not calculated": "Added by a user, not calculated",
  "The rate number in the calculation service, leave empty when the rate is not calculated": "The rate number in the calculation service, leave empty when the rate is not calculated",
  "Only for consumers": "Only for consumers",
  "This rate was added by a user and is not calculated": "This rate was added by a user and is not calculated",
  "Phone": "Phone",
  "OneDrive": "OneDrive",
  "Loading OneDrive settings": "Loading OneDrive settings",
  "Document sync": "Document sync",
  "The documents of your applications are copied to a folder per application in the OneDrive or SharePoint of your own Microsoft 365 tenant. Register an application in your tenant (Entra ID) with the application permission Files.ReadWrite.All and admin consent, and enter its details here.": "The documents of your applications are copied to a folder per application in the OneDrive or SharePoint of your own Microsoft 365 tenant. Register an application in your tenant (Entra ID) with the application permission Files.ReadWrite.All and admin consent, and enter its details here.",
  "Sync application documents to OneDrive": "Sync application documents to OneDrive",
  "Tenant id": "Tenant id",
  "Leave empty to keep the stored secret": "Leave empty to keep the stored secret",
  "SharePoint site url": "SharePoint site url",
  "The default document library of this site receives the documents": "The default document library of this site receives the documents",
  "Or the OneDrive of user": "Or the OneDrive of user",
  "Only used when no site url is entered": "Only used when no site url is entered",
  "Root folder": "Root folder",
  "A folder per application is created under this folder": "A folder per application is created under this folder",
  "Connection": "Connection",
  "Connected to": "Connected to",
  "The connection has not been tested yet": "The connection has not been tested yet",
  "Last synced": "Last synced",
  "Last run": "Last run",
  "new": "new",
  "uploaded": "uploaded",
  "removed": "removed",
  "failed": "failed",
  "Test connection": "Test connection",
  "Sync now": "Sync now",
  "Sync completed": "Sync completed",
  "The settings could not be saved": "The settings could not be saved",
  "The connection could not be tested": "The connection could not be tested",
  "The sync could not be started": "The sync could not be started",
  "Sync documents uploaded from": "Sync documents uploaded from",
  "Leave empty to sync all documents. Filled with today when the sync is switched on.": "Leave empty to sync all documents. Filled with today when the sync is switched on.",
  "Divide value in rented condition residential": "Divide value in rented condition residential",
  "Divide value in rented condition commercial": "Divide value in rented condition commercial",
  "What is the total value in rented condition residential?": "What is the total value in rented condition residential?",
  "What is the total value in rented condition commercial?": "What is the total value in rented condition commercial?",
  "How is the property rated?": "How is the property rated?",
  "Environment, legal provisions and permits": "Environment, legal provisions and permits",
  "Ground pollution": "Ground pollution",
  "Obligation to clean up ground pollution": "Obligation to clean up ground pollution",
  "Object pollution": "Object pollution",
  "Removal pollution cost": "Removal pollution cost",
  "Special private law provisions": "Special private law provisions",
  "Public law provisions": "Public law provisions",
  "Withdrawal permit needed": "Withdrawal permit needed",
  "Environmental permit needed": "Environmental permit needed",
  "Split permit needed": "Split permit needed",
  "Proof of fire safety needed": "Proof of fire safety needed",
  "Ratings": "Ratings",
  "Pro rata": "Pro rata",
  "OneDrive folder": "OneDrive folder",
  "SolidBriQ login": "SolidBriQ login",
  "Loading SolidBriQ login": "Loading SolidBriQ login",
  "Applications to SolidBriQ are filled in at the SolidBriQ portal with your own account. Enter your SolidBriQ login here. It is encrypted right away: nobody can read it back, not even Stingray.": "Applications to SolidBriQ are filled in at the SolidBriQ portal with your own account. Enter your SolidBriQ login here. It is encrypted right away: nobody can read it back, not even Stingray.",
  "Your SolidBriQ login is stored": "Your SolidBriQ login is stored",
  "Enter it again to replace it, e.g. after changing your password.": "Enter it again to replace it, e.g. after changing your password.",
  "Authenticator secret": "Authenticator secret",
  "Save login": "Save login",
  "Remove login": "Remove login",
  "SolidBriQ login saved": "SolidBriQ login saved",
  "The SolidBriQ login could not be saved": "The SolidBriQ login could not be saved",
  "Email address": "Email address",
  "Password": "Password",
  "Scan the QR code with the camera": "Scan the QR code with the camera",
  "QR code read": "QR code read",
  "Scan the authenticator QR code": "Scan the authenticator QR code",
  "Hold the QR code in front of the camera: the QR code shown when you set up two-factor authentication at SolidBriQ, or a Google Authenticator export (Transfer accounts, Export accounts, only your SolidBriQ account).": "Hold the QR code in front of the camera: the QR code shown when you set up two-factor authentication at SolidBriQ, or a Google Authenticator export (Transfer accounts, Export accounts, only your SolidBriQ account).",
  "This QR code is not an authenticator QR code": "This QR code is not an authenticator QR code",
  "This browser cannot use the camera here": "This browser cannot use the camera here",
  "Access to the camera was denied": "Access to the camera was denied",
  "No camera was found": "No camera was found",
  "Scan the QR code with the camera or upload a screenshot of it: the one shown when you set up two-factor authentication at SolidBriQ, or a Google Authenticator export. Or enter the code below the QR code.": "Scan the QR code with the camera or upload a screenshot of it: the one shown when you set up two-factor authentication at SolidBriQ, or a Google Authenticator export. Or enter the code below the QR code.",
  "Upload a screenshot of the QR code": "Upload a screenshot of the QR code",
  "Upload a screenshot": "Upload a screenshot",
  "Take a screenshot of the QR code on your phone and upload it here.": "Take a screenshot of the QR code on your phone and upload it here.",
  "The image could not be opened": "The image could not be opened",
  "No QR code was found in the image": "No QR code was found in the image"
}
